import React, {useMemo, useState} from "react";
import {Table, InputNumber, Button} from "antd";
import {useTheme} from "../../../../context/ThemeContext";
import {useTranslation} from "react-i18next";
import MoneyInput from "../../../../components/MoneyInput";

const SelectedCardList = ({ cards, onAmountChange, onDelete, disabled }) => {

    const { isDarkMode, toggleDarkMode } = useTheme();
    const { t, i18n } = useTranslation()

    const columnsSelectedCards = useMemo(() => [
        {
            title: t('clientId'),
            dataIndex: "client_uid",
            key: "client_uid",
            width: 100,
        },
        {
            title: t('mbat_id'),
            dataIndex: "mbat_id",
            key: "mbat_id",
            hidden: true
        },
        {
            title: t('contractId'),
            dataIndex: "contract_id",
            key: "contract_id",
            width: 100,
        },
        {
            title: t('embossedName'),
            dataIndex: "embossed_name",
            key: "embossed_name",
            width: 200,
        },
        {
            title: t('cardNumber'),
            dataIndex: "card_number",
            key: "card_number",
            width: 100,
            render: (_, record) => (
                record.card_number.replace(/(\d{4})(?=\d)/g, '$1 ')
            )
        },
        {
            title: t('sumpay'),
            dataIndex: "amount",
            key: "amount",
            width: 100,
            align: "right",
            render: (_, record) => (
                <MoneyInput value={record.amount} readOnly={disabled} onChange={(value) => onAmountChange(record.mbat_id, value)}  className='bm-input-number-align-right-nop-fwb'/>
                /*<InputNumber
                    style={{ width: "100%" }}
                    className="bm-input-number-align-right-nop-fwb"
                    value={record.amount}
                    onChange={(value) => onAmountChange(record.mbat_id, value)}
                    step={null}
                    controls={false}
                    formatter={(value) =>
                        `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                />*/
            ),
        },
        {
            title: t('dateExpire'),
            dataIndex: "date_expire",
            key: "date_expire",
            width: 100,
            render: (_, record) => {
                record.date_expire.replace(/(\d{2})(?=\d)/g, "$1/")
            }
        },
        {
            title: "",
            key: "action",
            width: 60,
            render: (_, record) =>
                !disabled || (
                <Button type="default" onClick={() => onDelete(record.mbat_id)}>
                    {t('delete')}
                </Button>
            ),
        },
    ], [onAmountChange, onDelete, i18n.language])

    return (

        <Table //rowSelection={rowSelection}
               columns={columnsSelectedCards}
               dataSource={cards}
               className={isDarkMode ? "table-striped-rows darkTheme" : "table-striped-rows"}
               rowKey="mbat_id"
               size='small'
               scroll={{x: 300, y:'calc(100vh - 450px)'}}
               tableLayout="auto"
               pagination={false}
        />
    );
};

export default React.memo(SelectedCardList);